<template>
  <v-container class="py-6" fluid>
    <v-row justify="center">
      <v-col cols="12" md="10" lg="8">
        <v-card elevation="2">

          <v-toolbar flat color="transparent">
            <v-toolbar-title class="text-h6 text-md-h5">Cargar disponibilidad</v-toolbar-title>
          </v-toolbar>

          <v-divider></v-divider>

          <v-card-text>
            <v-form ref="form" lazy-validation>
              <v-row dense>

                <!-- Día -->
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="form.dia"
                    :items="diasSemana"
                    item-text="label"
                    item-value="value"
                    label="Día de la semana"
                    prepend-icon="mdi-calendar-week"
                    :rules="[v => !!v || 'Seleccioná un día']"
                    clearable
                    @change="form.horario = null"
                  />
                </v-col>

                <!-- Modalidad -->
                <v-col cols="12" sm="4">
                  <v-select
                    v-model="form.modalidad"
                    :items="modalidades"
                    item-text="text"
                    item-value="value"
                    label="Modalidad"
                    prepend-icon="mdi-laptop"
                    :rules="[v => !!v || 'Seleccioná la modalidad']"
                    @change="form.horario = null"
                  />
                </v-col>

                <!-- Horario para SEMIPRESENCIAL -->
                <v-col cols="12" sm="4" v-if="form.modalidad === 'S'">
                  <v-select
                    v-model="form.horario"
                    :items="horariosSemi"
                    item-text="label"
                    item-value="value"
                    label="Horario (semi-presencial)"
                    prepend-icon="mdi-clock-outline"
                    :rules="[v => !!v || 'Elegí un horario']"
                  />
                </v-col>

                <!-- Horario para DISTANCIA -->
                <v-col cols="12" sm="4" v-else-if="form.modalidad === 'D'">
                  <v-menu
                    v-model="menus.horario"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    max-width="290"
                    min-width="290"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="form.horario"
                        label="Hora inicio tutoría"
                        prepend-icon="mdi-clock-outline"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        :rules="[
                          v => !!v || 'Requerido',
                         v => !v || estaDentroDeRangoDistancia(v) || 'Debe ser entre 18:00 y 21:00'
                        ]"
                      />
                    </template>

                    <v-time-picker
                      v-if="menus.horario"
                      v-model="form.horario"
                      format="24hr"
                      full-width
                      @click:minute="menus.horario = false"
                      :allowed-hours="horasPermitidas"
                    />
                  </v-menu>
                </v-col>

                <!-- Botón agregar -->
                <v-col cols="12" class="d-flex align-center">
                  <v-btn color="primary" class="mr-2" @click="agregarDisponibilidad" :loading="loading">
                    <v-icon left>mdi-plus</v-icon> Agregar Disponibilidad
                  </v-btn>

                  <span class="text-caption grey--text">
                    Podés agregar varios horarios en el mismo día. Evitamos solapamientos automáticamente.
                  </span>
                </v-col>

              </v-row>
            </v-form>

            <!-- Tabla -->
            <v-slide-y-transition>
              <div v-if="slots.length" class="mt-6">
                <v-data-table
                  :headers="headers"
                  :items="itemsTabla"
                  disable-pagination
                  hide-default-footer
                  class="elevation-1"
                >
                  <template v-slot:item.horario="{ item }">
                    {{ item.horario }} – {{
                      minutesToHHMM(
                        toMinutes(item.horario) +
                        duracionPorModalidad(item.modalidad)
                      )
                    }}
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          color="error"
                          v-bind="attrs"
                          v-on="on"
                          @click="eliminarDisponibilidad(item.__idx)"
                          :loading="loading"
                        >
                          <v-icon small>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                  </template>

                </v-data-table>
              </div>
            </v-slide-y-transition>

          </v-card-text>

          <v-divider></v-divider>
        </v-card>
      </v-col>
    </v-row>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3500" top>
      {{ snackbar.text }}
    </v-snackbar>
  </v-container>
</template>


<script>
import DisponibilidadService from "../../services/Disponibilidad.service"

export default {
  name: "DisponibilidadPage",

  data() {
    return {
      loading: false,
      silentReset: false,
      form: {
        dia: null,
        modalidad: "",
        horario: null
      },
      diasSemana: [
        { label: "Lunes", value: 2 },
        { label: "Martes", value: 3 },
        { label: "Miércoles", value: 4 },
        { label: "Jueves", value: 5 },
        { label: "Viernes", value: 6 },
        { label: "Sábado", value: 7 }
      ],
      modalidades: [
        { text: "Distancia", value: "D" },
        { text: "SemiPresencial", value: "S" }
      ],
      menus: { horario: false },
      slots: [],
      headers: [
        { text: "Día", value: "dia" },
        { text: "Horario", value: "horario" },
        { text: "Modalidad", value: "modalidad" },
        { text: "", value: "actions", sortable: false, align: "end" }
      ],
      snackbar: { show: false, text: "", color: "success" }
    }
  },

  computed: {
    itemsTabla() {
      return this.slots.map(s => ({
        __idx: s.disponibilidadId,
        dia: s.dia,
        horario: s.hora,
        modalidad: s.Modalidad === "D" ? "Distancia" : "SemiPresencial"
      }))
    },

    horariosSemi() {
      const esSabado = this.form.dia === 7

      const base = [
        { label: "15:00", value: "15:00" },
        { label: "19:00", value: "19:00" }
      ]

      const sabado = [
        { label: "09:30", value: "09:30" },
        { label: "13:30", value: "13:30" },
        { label: "14:00", value: "14:00" }
      ]

      return esSabado ? sabado : base
    }
  },

  methods: {
    /* ========== Helpers generales ========== */

    toMinutes(hhmm) {
      const [h, m] = hhmm.split(":").map(Number)
      return h * 60 + m
    },

    minutesToHHMM(min) {
      const h = Math.floor(min / 60)
      const m = min % 60
      return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`
    },

    duracionPorModalidad(modalidad) {
      return modalidad === "Distancia" ? 90 : 135
    },

    dayLabel(value) {
      const dia = this.diasSemana.find(d => d.value === value)
      return dia ? dia.label : value
    },

    mostrarAviso(texto, color = "success") {
      this.snackbar = { show: true, text: texto, color }
    },

    horasPermitidas(h) {
      if (this.form.modalidad === "S") {
        return [9, 13, 14, 15, 19].includes(h)
      }
      return h >= 18 && h <= 21
    },

    estaDentroDeRangoDistancia(hhmm) {
      if (!hhmm) return false
      const min = this.toMinutes(hhmm)
      return min >= this.toMinutes("18:00") && min <= this.toMinutes("21:00")
    },

    hasOverlap(dia, horario, modalidad) {
      const inicioNuevo = this.toMinutes(horario)
      const diaLabel = this.dayLabel(dia)

      return this.slots.some(s => {
        if (s.dia !== diaLabel) return false
        return this.toMinutes(s.hora) === inicioNuevo && s.Modalidad === modalidad
      })
    },

    reiniciarFormulario() {
      this.silentReset = true

      this.form = {
        dia: this.form.dia,
        modalidad: this.form.modalidad,
        horario: null
      }

      this.$nextTick(() => {
        this.$refs.form.resetValidation()
        this.silentReset = false
      })
    },

    /* ========== API ========== */

    agregarDisponibilidad() {
      const valido = this.$refs.form.validate()
      if (!valido) return

      if (!this.form.horario) {
        return this.mostrarAviso("Elegí un horario", "error")
      }

      if (
        this.form.modalidad === "D" &&
        !this.estaDentroDeRangoDistancia(this.form.horario)
      ) {
        return this.mostrarAviso("La hora debe ser entre 18:00 y 21:00", "error")
      }

      if (this.hasOverlap(this.form.dia, this.form.horario, this.form.modalidad)) {
        return this.mostrarAviso("Ese horario ya existe en ese día", "error")
      }

      const payload = {
        dia: this.dayLabel(this.form.dia),
        diaSemana: this.form.dia,
        docenteId: 0,
        horario: this.form.horario,
        modalidad: this.form.modalidad
      }

      this.loading = true

      DisponibilidadService.Agregar(payload)
        .then(res => {
          this.slots = res.data
          this.reiniciarFormulario()
          this.mostrarAviso("Horario agregado")
        })
        .catch(err => this.mostrarAviso(err.response.data, "error"))
        .finally(() => (this.loading = false))
    },

    eliminarDisponibilidad(id) {
      this.loading = true

      DisponibilidadService.Eliminar(id)
        .then(res => {
          this.slots = res.data
          this.reiniciarFormulario()
          this.mostrarAviso("Horario eliminado", "info")
        })
        .catch(err => this.mostrarAviso(err, "error"))
        .finally(() => (this.loading = false))
    },

    cargarDisponibilidad() {
      this.loading = true
      DisponibilidadService.Obtener()
        .then(res => (this.slots = res.data))
        .catch(err => this.mostrarAviso(err, "error"))
        .finally(() => (this.loading = false))
    }
  },

  mounted() {
    this.cargarDisponibilidad()
  }
}
</script>


<style scoped>
.v-text-field,
.v-select {
  margin-bottom: 8px;
}

:deep(.v-data-table) {
  overflow-x: auto;
}
</style>
